/**
 * Initialize all map blocks on the page.
 */
function initMapBlocks() {
	const blocks = /** @type {HTMLElement[]} */ ( Array.from( document.querySelectorAll( '.wp-block-wdg-map-locations' ) ) );

	blocks.forEach( ( block ) => {
		const mode = block.dataset.mode || 'click';

		/** @type {HTMLElement | null} */
		const mapContainer = block.querySelector( '.wp-block-wdg-map-locations__map' );
		if ( ! mapContainer ) {
			return;
		}

		const items = /** @type {HTMLElement[]} */ ( Array.from( block.querySelectorAll( '.wp-block-wdg-map-location' ) ) );
		if ( ! items.length ) {
			mapContainer.textContent = 'No locations defined.';
			return;
		}

		const firstItem = items[ 0 ];
		const firstLat = parseFloat( firstItem.dataset.lat || '0' );
		const firstLng = parseFloat( firstItem.dataset.lng || '0' );

		const map = new google.maps.Map( mapContainer, {
			center: { lat: firstLat, lng: firstLng },
			zoom: 4,
			styles: [
				{
					elementType: 'geometry',
					stylers: [
						{
							color: '#133064',
						},
					],
				},
				{
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#d8ebff',
						},
					],
				},
				{
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#0e2a5d',
						},
					],
				},
				{
					featureType: 'administrative.land_parcel',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#64779e',
						},
					],
				},
				{
					featureType: 'landscape.man_made',
					elementType: 'geometry.stroke',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'landscape.natural',
					elementType: 'geometry',
					stylers: [
						{
							color: '#0e2a5d',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'geometry',
					stylers: [
						{
							color: '#1d4a94',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text.fill',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#1d4a94',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#d8ebff',
						},
						{
							lightness: -20,
						},
						{
							visibility: 'on',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#d8ebff',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'geometry',
					stylers: [
						{
							color: '#1d4a94',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#98a5be',
						},
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#1d2c4d',
						},
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry',
					stylers: [
						{
							color: '#1d4a94',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry.stroke',
					stylers: [
						{
							color: '#1d4a94',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.fill',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'transit',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'transit.line',
					elementType: 'geometry.fill',
					stylers: [
						{
							color: '#1d4a94',
						},
					],
				},
				{
					featureType: 'transit.station',
					elementType: 'geometry',
					stylers: [
						{
							color: '#3a4762',
						},
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [
						{
							color: '#041130',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#d8ebff',
						},
						{
							saturation: 65,
						},
						{
							lightness: -25,
						},
					],
				},
			],
			mapTypeControl: false,
			streetViewControl: false,
		} );

		items.forEach( ( item ) => {
			const lat = parseFloat( item.dataset.lat || '' );
			const lng = parseFloat( item.dataset.lng || '' );

			if ( isNaN( lat ) || isNaN( lng ) ) {
				return;
			}

			const marker = new google.maps.Marker( {
				position: { lat, lng },
				map,
			} );

			const handler = () => {
				animateMapTo( map, { lat, lng }, 1200 );
			};

			if ( mode === 'hover' ) {
				item.addEventListener( 'mouseenter', handler );
				marker.addListener( 'mouseover', handler );
			} else {
				item.addEventListener( 'click', handler );
				marker.addListener( 'click', handler );
			}
		} );
	} );

	/**
	 * Smoothly animate map center and zoom to a new location.
	 *
	 * @param {google.maps.Map}              map
	 * @param {{ lat: number, lng: number }} target
	 * @param {number}                       duration
	 */
	function animateMapTo( map, target, duration = 1000 ) {
		const start = map.getCenter();
		if ( ! start ) {
			return;
		}

		const startLat = start.lat();
		const startLng = start.lng();

		const deltaLat = target.lat - startLat;
		const deltaLng = target.lng - startLng;

		let startTime;

		function step( timestamp ) {
			if ( ! startTime ) {
				startTime = timestamp;
			}
			const progress = Math.min( ( timestamp - startTime ) / duration, 1 );

			const ease =
				progress < 0.5
					? 2 * progress * progress // ease-in
					: -1 + ( 4 - 2 * progress ) * progress;

			const lat = startLat + deltaLat * ease;
			const lng = startLng + deltaLng * ease;

			map.setCenter( { lat, lng } );

			if ( progress < 1 ) {
				window.requestAnimationFrame( step );
			}
		}

		window.requestAnimationFrame( step );
	}
}

/**
 * Initialize maps when both DOM and Google Maps API are ready.
 */
async function init() {
	// Wait for Google Maps to load the maps library
	await google.maps.importLibrary( 'maps' );

	// Initialize the map blocks
	initMapBlocks();
}

// Start when DOM is ready
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	// DOM already loaded
	init();
}
